import { render } from "./ActiveNFRs.vue?vue&type=template&id=1fa83dba"
import script from "./ActiveNFRs.vue?vue&type=script&lang=js"
export * from "./ActiveNFRs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__